import { configureStore } from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';

const localStorageMiddleware = ({ getState }) => next => action => {
  const result = next(action);
  localStorage.setItem('theme-settings', JSON.stringify(getState().customizer));
  return result;
};

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(localStorageMiddleware),
});


export default store;
